module.exports = __webpack_public_path__ + "img/alea-logo.b471222b.jpg";